import { InventoryAdjustmentPrintPage } from '@/features/inventory-adjustment/pages/InventoryAdjustmentPrintPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/inventory-adjustment/$id/print')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_adjustment.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryAdjustmentPrintPage,
})
